import { all, put, takeEvery } from "redux-saga/effects";
import { fetcher, getErrorMsg, handleError } from "lib/fetch";
import * as actions from "./actions";

const url = "products";

function* loadProducts(action) {
  try {
    const { params, token } = action.payload;
    const res = yield fetcher.post(url, params, token);
    yield put(actions.loadProducts.success(res.data));
  } catch (error) {
    handleError(error);
    yield put(actions.loadProducts.failure(getErrorMsg(error)));
  }
}

function* showProduct(action) {
  try {
    const { id, token } = action.payload;
    const res = yield fetcher.get(`${url}/${id}`, token);
    yield put(actions.showProduct.success(res.data));
  } catch (error) {
    handleError(error);
    yield put(actions.showProduct.failure(getErrorMsg(error)));
  }
}

function* createProduct(action) {
  try {
    const { params, token } = action.payload;
    const res = yield fetcher.post(`${url}/create`, params, token);
    yield put(actions.createProduct.success(res.data));
  } catch (error) {
    handleError(error);
    yield put(actions.createProduct.failure(getErrorMsg(error)));
  }
}

function* updateProduct(action) {
  try {
    const { params, id, token } = action.payload;
    const res = yield fetcher.post(`${url}/update/${id}`, params, token);
    yield put(actions.updateProduct.success(res.data));
  } catch (error) {
    handleError(error);
    yield put(actions.updateProduct.failure(getErrorMsg(error)));
  }
}

function* exportProduct(action) {
  try {
    const { params, token } = action.payload;
    const res = yield fetcher.post(`${url}/export`, params, token);
    yield put(actions.exportProduct.success(res.data));
    fetcher.download(res.data.data);
  } catch (error) {
    handleError(error);
    yield put(actions.exportProduct.failure(getErrorMsg(error)));
  }
}

function* importProduct(action) {
  try {
    const { file, company_id, mode, token } = action.payload;
    const formData = new FormData();
    formData.append("file_name", file.originFileObj);
    formData.append("company_id", company_id);
    formData.append("mode", mode);
    const res = yield fetcher.upload(`${url}/import`, formData, token);
    yield put(actions.importProduct.success(res.data));
  } catch (error) {
    handleError(error);
    yield put(actions.importProduct.failure(getErrorMsg(error)));
  }
}

function* deleteProduct(action) {
  try {
    const { id, token } = action.payload;
    yield fetcher.get(`${url}/delete/${id}`, token);
    yield put(actions.deleteProduct.success(id));
  } catch (error) {
    handleError(error);
    yield put(actions.deleteProduct.failure(getErrorMsg(error)));
  }
}


export default function* watchProducts() {
  yield all([
    takeEvery(actions.LOAD_PRODUCT.REQUEST, loadProducts),
    takeEvery(actions.SHOW_PRODUCT.REQUEST, showProduct),
    takeEvery(actions.CREATE_PRODUCT.REQUEST, createProduct),
    takeEvery(actions.UPDATE_PRODUCT.REQUEST, updateProduct),
    takeEvery(actions.EXPORT_PRODUCT.REQUEST, exportProduct),
    takeEvery(actions.IMPORT_PRODUCT.REQUEST, importProduct),
    takeEvery(actions.DELETE_PRODUCT.REQUEST, deleteProduct),
  ]);
}


